import React from "react"
import SbEditable from "storyblok-react"

import { DynamicComponent } from ".."
import { Container } from "../../.base/container"
import { PageTitle } from "../../.base/headings"

const Page = ({ blok }) => {
  const content =
    blok.body &&
    blok.body.map(childBlok => <DynamicComponent blok={childBlok} key={childBlok._uid}/>)
  const hasTitle = blok.title.length ? (<PageTitle className="u-h0">{blok.title}</PageTitle>) : null
  return (
    <SbEditable content={blok}>
      <div className="App">
        <Container>
          { hasTitle }
          { content }
        </Container>
      </div>
    </SbEditable>
  )
}
 
export default Page